(function ($) {
  Drupal.behaviors.contentBlockFormatterV1 = {
    attach: function (context) {
      var $template = $('.js-content-block-filter-formatter--v1', context);
      var $grid = $('.js-content-block-formatter-grid', $template);
      var $gridItem = $('.js-grid-item', $template);
      var $filterSelect = $('select.js-content-block-formatter-filter__dropdown', $template);
      var $loadMore = $('.js-content-block-formatter-filter__load-more', $template);
      var $loadMoreBtn = $('.js-content-block-formatter-filter__load-more-btn', $template);
      var loadMoreCount = $loadMoreBtn.attr('data-show');

      $filterSelect.children('option').each(function () {
        var value = this.value;
        var $optionGridItems = $('.js-filter--' + value, $grid);

        if (value !== '' && $optionGridItems.length === 0) {
          this.remove();
          $(document).trigger('selectBox.initOne', [$filterSelect]);
        }
      });

      var mixer = mixitup($grid, {
        selectors: {
          target: '.content-block-formatter-filter__item'
        },
        controls: {
          enable: false
        },
        animation: {
          enable: false
        },
        callbacks: {
          onMixStart: function (state, futureState) {
            $loadMore.hide();
          }
        }
      });

      if (loadMoreCount) {
        $gridItem.slice(loadMoreCount, $gridItem.length).hide();
      }

      $filterSelect.on('change', function () {
        var value = this.value;
        var newValue = 'all';

        if (value) {
          newValue = '.js-filter--' + value;
        }
        filterByType(newValue);
      });

      function filterByType(filterValue) {
        $('.js-grid-item').css('display', '');
        mixer.filter(filterValue);
        $('.js-grid-item').each(function () {
          if ($(this).find('.content-block-formatter-filter__item').css('display') === 'none') {
            $(this).css('display', 'none');
          }
        });
      }

      if ($gridItem.length > loadMoreCount) {
        $loadMore.show();
      } else {
        $loadMore.hide();
      }

      $loadMoreBtn.on('click', function () {
        if ($gridItem.is(':hidden')) {
          $('.js-grid-item:hidden').slice(0, loadMoreCount).fadeIn(400);
        } else {
          $loadMore.hide();
        }
      });
    }
  };
})(jQuery);
